import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessagingSystem } from 'src/app/classes/messages/messaging.system';
import { Settings } from 'src/app/classes/settings/settings';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  readonly MessagingSystem = MessagingSystem;

  algorithm: MessagingSystem = MessagingSystem.SprayAndWait;
  numNodes: number = this.settings.DEFAULT_NUMBER_OF_NODES;
  simSpeed: number = this.settings.DEFAULT_SIMULATION_SPEED;
  simTime: number = this.settings.DEFAULT_SIMULATION_TIME;
  nodeRadius: number = this.settings.DEFAULT_NODE_RADIUS;
  msgFreq: number = this.settings.DEFAULT_MESSAGE_FREQUENCY;
  numMsgCopies: number = this.settings.DEFAULT_MESSAGE_COPIES;

  constructor(private router: Router, private route: ActivatedRoute, public settings: Settings) {}

  ngOnInit(): void {
    if(this.route.snapshot.paramMap.get('reload') == '1') {
      this.router.routeReuseStrategy.shouldReuseRoute = () => false;
      this.router.onSameUrlNavigation = 'reload';
      this.router.navigate(['/']);
    }
  }

  startSimulation() {
    this.router.navigate(['/simulator', 
      this.algorithm, 
      this.numNodes, 
      this.simSpeed, 
      this.simTime, 
      this.nodeRadius, 
      this.msgFreq,
      this.numMsgCopies
    ]);
  }

  updateNumNodes(numNodesElem: HTMLInputElement) {
    this.numNodes = parseInt(numNodesElem.value);
  }

  updateSimSpeed(simSpeedElem: HTMLInputElement) {
    this.simSpeed = parseFloat(simSpeedElem.value);
  }

  updateAlgorithm(algorithmElem: HTMLInputElement|null) {
    if(algorithmElem == null) {
      this.algorithm = MessagingSystem.SprayAndWait;
      return;
    }

    this.algorithm = <MessagingSystem><unknown>algorithmElem.value
  }

  updateSimTime(simTimeElem: HTMLInputElement) {
    this.simTime = parseInt(simTimeElem.value);
  }

  updateNodeRadius(nodeRadiusElem: HTMLInputElement) {
    this.nodeRadius  = parseInt(nodeRadiusElem.value);
  }

  updateMsgFreq(msgFreqElem: HTMLInputElement) {
    this.msgFreq = parseInt(msgFreqElem.value);
  }

  updateNumMsgCopies(msgCopiesElem: HTMLInputElement) {
    this.numMsgCopies = parseInt(msgCopiesElem.value);
  }

}
